const FR_LOCALE = 'fr-FR';

const DEFAULT_CURRENCY_OPTIONS = {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const formatNumber = (number, options = {}) =>
  new Intl.NumberFormat(FR_LOCALE, options).format(parseFloat(number));

export const formatNumberCurrency = (number, options = DEFAULT_CURRENCY_OPTIONS) => {
  return new Intl.NumberFormat(FR_LOCALE, options).format(number);
};

// Format payload to ensure matching with API
export const toNumber = (val, type) => {
  if (val !== undefined) {
    const intval = type === 'FLOAT' ? parseFloat(val) : parseInt(val, 10);
    if (!isNaN(intval)) {
      return intval;
    }
  }

  return null;
};
